import { useEffect } from "react";

const useFavicon = (iconPath: string) => {
  useEffect(() => {
    document
      .querySelector("link[rel~='icon']")
      ?.setAttribute("href", `${process.env.PUBLIC_URL}${iconPath}`);
  }, [iconPath]);
};

export default useFavicon;
